import React, { FC } from 'react'
import classNames from 'classnames'
import text from 'styles/utility/text.module.scss'
import { FlexRow } from 'components/Flex'
import { Checkbox } from 'components/Form'
import { Spacer } from 'components/Utility'
import { OrderType } from 'types/checkout'

type Props = {
  order: OrderType
}

const PrintOrderPickupTime: FC<Props> = (props) => {
  const { order } = props
  return (
    <FlexRow justifyContent={'between'}>
      <FlexRow justifyContent={'start'}>
        <span className={classNames(text.font_mediumLarge, text.font_bold)}>来店予定時刻&nbsp;:&nbsp;</span>
        <span className={classNames(text.font_xlarge, text.font_bold, text.color_orange_main)}>
          {order.pickup_time}
        </span>
      </FlexRow>
      <FlexRow justifyContent={'end'}>
        <Checkbox
          disabled={true}
          fontSize={14}
          id={order.checkout_id ?? ''}
          isChecked={order.is_prepared}
          label={'準備済'}
        />
        <Spacer size={8} />
        <Checkbox
          disabled={true}
          fontSize={14}
          id={order.checkout_id ?? ''}
          isChecked={order.is_delivered}
          label={'受渡済'}
        />
      </FlexRow>
    </FlexRow>
  )
}

export default PrintOrderPickupTime
